var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      title: _vm.dataFrom.documentId ? _vm.$t("编辑") : _vm.$t("新增"),
      visible: _vm.dialogVisible,
      okText: _vm.$t("确认"),
      cancelText: _vm.$t("取消"),
      width: 1000
    },
    on: {
      ok: _vm.handleSure,
      cancel: () => {
        _vm.$emit("cancel");
      }
    }
  }, [_c("a-form-model", {
    ref: "dataFrom",
    attrs: {
      model: _vm.dataFrom,
      rules: _vm.dataRule,
      "label-col": {
        span: 5
      },
      "wrapper-col": {
        span: 18
      }
    }
  }, [_c("a-form-model-item", {
    attrs: {
      prop: "type",
      label: _vm.$t("变量类型")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("变量类型"),
      disabled: _vm.dataFrom.documentId ? true : false
    },
    model: {
      value: _vm.dataFrom.type,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "type", $$v);
      },
      expression: "dataFrom.type"
    }
  }, _vm._l(_vm.TYPE, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(_vm.$t(item.name)))]);
  }), 1)], 1), _c("a-form-model-item", {
    attrs: {
      prop: "unitId",
      label: _vm.$t("承保单位")
    }
  }, [_c("a-select", {
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("承保单位"),
      "filter-option": _vm.dropDownSearchNo,
      "show-search": "",
      disabled: _vm.dataFrom.documentId ? true : false
    },
    model: {
      value: _vm.dataFrom.unitId,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "unitId", $$v);
      },
      expression: "dataFrom.unitId"
    }
  }, _vm._l(_vm.unitList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1)], 1), _c("a-form-model-item", {
    attrs: {
      prop: "name",
      label: _vm.$t("文件名称")
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("文件名称")
    },
    model: {
      value: _vm.dataFrom.name,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "name", $$v);
      },
      expression: "dataFrom.name"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("文件备注"),
      prop: "remark"
    }
  }, [_c("a-textarea", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("文件备注")
    },
    model: {
      value: _vm.dataFrom.remark,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "remark", $$v);
      },
      expression: "dataFrom.remark"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("文本内容"),
      prop: "content"
    }
  }, [_c("quill-editor", {
    ref: "myTextEditor",
    staticStyle: {
      height: "300px",
      width: "100%"
    },
    attrs: {
      options: _vm.quillOption
    },
    model: {
      value: _vm.dataFrom.content,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "content", $$v);
      },
      expression: "dataFrom.content"
    }
  })], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };